import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CancelOperationType, MovementOrderStatus, TransferOrderStatus } from '../../../../enums/enum';

@Component({
  selector: 'app-cancel-operation',
  standalone: false,
  templateUrl: './cancel-operation.component.html',
  styleUrl: './cancel-operation.component.css',
})
export class CancelOperationComponent {
  @Input() referenceNumber!: string;
  @Input() orderType!: CancelOperationType;
  @Input() status!: number;

  @Output() confirm = new EventEmitter<CancelOperationType>();

  movementOrderStatus = MovementOrderStatus;
  cancelOperationType = CancelOperationType;
  transferOrderStatus = TransferOrderStatus;

  onConfirm(): void {
    this.confirm.emit(this.orderType);
  }
}
